module.exports = __webpack_public_path__ + "static/media/Apple iPhone XS Max Silver.ccea74ba.png";